import React from 'react';

const SubTitle = ({actions, children}) => (
    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-3 mb-4">
        <h3>{children}</h3>
        {actions}
    </div>
);

export default SubTitle;
